import React from 'react';
import {View, Text} from 'react-native';
import {IconButton} from 'react-native-paper';
import UserName from 'src/modules/scheduling/components/user-name';
import {useStyle} from 'src/providers/style';
import {Colors, Typography} from 'src/styles';

interface Props {
  item: any;
  canEdit: boolean;
  editCallback: (item: any) => void;
  canDelete: boolean;
  deleteCallback: (item: any) => void;
}

const TimelineItem = ({
  item,
  canEdit,
  editCallback,
  canDelete,
  deleteCallback,
}: Props) => {
  const styles = useStyle();

  return (
    <View>
      <View
        style={[styles.row, styles.justifySpaceBetween, styles.alignCenter]}>
        {item.entity === 'patient' ? <UserName id={item.createdBy} /> : <></>}
        <View style={[styles.row, styles.alignCenter]}>
          {canEdit ? (
            <IconButton
              size={18}
              color={Colors.GRAY_500}
              icon="pencil"
              onPress={() => editCallback(item)}
            />
          ) : (
            <></>
          )}
          {canDelete ? (
            <IconButton
              size={18}
              color={Colors.GRAY_500}
              icon="trash-can"
              onPress={() => deleteCallback(item)}
            />
          ) : (
            <></>
          )}
        </View>
      </View>
      {item?.title ? (
        <Text
          style={[
            Typography.CAPTION,
            styles.marginLVertical,
            styles.marginLLeft,
            styles.textColorPrimary,
          ]}>
          {item?.title}
        </Text>
      ) : (
        <></>
      )}
      <Text
        style={[
          Typography.CAPTION,
          styles.marginBottom,
          styles.textColorPrimary,
        ]}>
        {item?.description}
      </Text>
    </View>
  );
};

export default TimelineItem;
